export default __webpack_public_path__ + "static/media/la.afcfb714.jpg";